import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    StepperListDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    horizontal: {
        alignItems: "flex-start",
        flexDirection: "row"
    },
    vertical: {
        flexDirection: "column",
        alignItems: "stretch"
    },
    container: {
        minWidth: 0
    }
});

export const useStyles = ({
    orientation,
    isInSheet,
    measures,
    spaces
}: StepperListDynamicStyleType) => {
    const styles = {
        container: {} as Mutable<ViewStyle>
    };

    if(!isInSheet) {
        styles.container.marginStart = -measures.inset;
    }

    if(orientation === "horizontal") {
        styles.container.gap = spaces.spacingSm;
    }

    if(orientation === "vertical") {
        styles.container.marginVertical = (measures.markerSize - measures.rowHeight) / 2;
    }

    return styles;
};
export default stylesheet;
